export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.deleted = item != null ? item.deleted ? 'true' : 'false' : 'true'
        this.name = item != null ? item.name : ''
    }
}